// @ts-ignore
import React, { Fragment, useErrorBoundary } from 'react';
import { useSelector } from 'react-redux';
import { globals } from '../utils';
import cleanDeeplink from '../utils/cleanDeeplink';
import { reportFlexEvent } from '../utils/reportFlexEvent';
;
export default function ErrorBoundary(props) {
    useErrorBoundary(async (error) => {
        const { UAParser } = await import(/* webpackChunkName: "metrics" */ 'ua-parser-js');
        const ua = new UAParser(globals.navigator.userAgent);
        const browser = ua.getBrowser();
        const { Authentication } = useSelector((state) => state);
        reportFlexEvent(`WebPlayerClientError`, [
            [
                getDeeplink(),
                ua.getOS().name,
                browser.name,
                error.message
            ], [
                Number(browser.major)
            ]
        ], Authentication);
        return React.createElement(Fragment, null, props.children);
    });
    return React.createElement(Fragment, null, props.children);
    function getDeeplink() {
        var _a, _b, _c, _d, _e;
        const { currentTemplate, overlayTemplates } = useSelector((state) => state.TemplateStack);
        const deeplink = (((_c = (_b = (_a = overlayTemplates[0]) === null || _a === void 0 ? void 0 : _a.innerTemplate) === null || _b === void 0 ? void 0 : _b.templateData) === null || _c === void 0 ? void 0 : _c.deeplink) || ((_e = (_d = currentTemplate) === null || _d === void 0 ? void 0 : _d.templateData) === null || _e === void 0 ? void 0 : _e.deeplink) || '');
        return cleanDeeplink(deeplink);
    }
}
;
